//API
export const FETCH_START = "FETCH_START";
export const FETCH_SUCCESS = "FETCH_SUCCESS";
export const FETCH_ERROR = "FETCH_ERROR";
export const SHOW_MESSAGE = "SHOW_MESSAGE";
export const HIDE_MESSAGE = "HIDE_MESSAGE";
export const TOGGLE_APP_DRAWER = "TOGGLE_APP_DRAWER";
export const UPDATING_CONTENT = "UPDATING_CONTENT";

//APP SETTING
export const TOGGLE_NAV_COLLAPSED = "TOGGLE_NAV_COLLAPSED";
export const SET_INITIAL_PATH = "SET_INITIAL_PATH";

//AUTH0
export const UPDATE_AUTH_USER = "update_auth_user";
export const SET_AUTH_TOKEN = "set_auth_token";
export const SIGNOUT_AUTH_SUCCESS = "signout_auth_success";

// Travel Request
export const GET_TRAVEL_REQUEST = "get_travel_request";
export const GET_TRAVEL_REQUEST_ERRORS = "get_travel_request_errors";
export const CREATE_TRAVEL_REQUEST = "create_travel_request";
export const CREATE_TRAVEL_REQUEST_ERROR = "create_travel_request_error";
export const DELETE_TRAVEL_REQUEST = "delete_travel_request";
export const DELETE_TRAVEL_REQUEST_ERROR = "delete_travel_request_error";
export const UPDATE_TRAVEL_REQUEST = "update_travel_request";
export const UPDATE_TRAVEL_REQUEST_ERROR = "update_travel_request_error";
// Travel Request pending By Manager
export const GET_TRAVEL_PENDING_MANAGER = "get_travel_pending_manager";
export const GET_TRAVEL_PENDING_MANAGER_ERRORS =
    "get_travel_pending_manager_errors";
export const GET_TRAVEL_LOGS_MANAGER = "get_travel_logs_manager";
export const GET_TRAVEL_LOGS_MANAGER_ERRORS = "get_travel_logs_manager_errors";
// loader
export const LOADING_END = "loading_end";
// Leave Request
export const LEAVE_LOGS = "leave_logs";
export const LEAVE_LOGS_ERROR = "leave_logs_erros";
export const GET_LEAVE_LOGS_REQUESTS = "GET_LEAVE_LOGS_REQUESTS";
export const RESET_LEAVE_LOGS_REQUESTS = "RESET_LEAVE_LOGS_REQUESTS";
export const GET_LEAVE_REQUESTS = "GET_LEAVE_REQUESTS";
export const RESET_LEAVE_REQUESTS = "RESET_LEAVE_REQUESTS";
export const GET_PENDING_LEAVE_REQUESTS = "GET_PENDING_LEAVE_REQUESTS";
export const RESET_PENDING_LEAVE_REQUESTS = "RESET_PENDING_LEAVE_REQUESTS";
export const GET_APPROVED_LEAVE_REQUESTS = "GET_APPROVED_LEAVE_REQUESTS";
export const RESET_APPROVED_LEAVE_REQUESTS = "RESET_APPROVED_LEAVE_REQUESTS";
export const GET_LEAVE_DETAILS = "GET_LEAVE_DETAILS";
export const RESET_LEAVE_DETAILS = "RESET_LEAVE_DETAILS";
export const CREATE_LEAVE_REQUEST = "CREATE_LEAVE_REQUEST";
export const DELETE_LEAVE_REQUEST = "DELETE_LEAVE_REQUEST";
export const CANCEL_LEAVE_REQUEST = "CANCEL_LEAVE_REQUEST";
export const COMPLETE_LEAVE_REQUEST = "COMPLETE_LEAVE_REQUEST";
export const UPDATE_LEAVE_REQUEST = "UPDATE_LEAVE_REQUEST";
export const UPDATE_LEAVE_REQUEST_STATUS = "UPDATE_LEAVE_REQUEST_STATUS";
export const DELETE_FILE_LEAVE_REQUEST = "DELETE_FILE_LEAVE_REQUEST";
export const DELETE_ROW_LEAVE_REQUEST = "DELETE_ROW_LEAVE_REQUEST";
// leave Status
export const GET_LEAVE_STATUS = "get_leave_status";
export const GET_LEAVE_STATUS_ERROR = "get_leave_status_error";
// Ashramwashi Portal
export const GET_Ashramwashi_Events = "get_ashramwashi_events";
export const GET_Ashramwashi_Events_ERROR = "get_ashramwashi_events_error";
// room booking
export const BOOKING_REQUEST_LIST = "BOOKING_REQUEST_LIST";
export const BOOKING_DETAILS = "BOOKING_DETAILS";
export const BOOKING_APPROVAL_LIST = "BOOKING_APPROVAL_LIST";
export const BOOKING_FRONTDESK_LIST = "BOOKING_FRONTDESK_LIST";
export const ERROR = "ERROR";
export const DELETE_REQUEST = "DELETE_REQUEST";
export const BOOKING_CHECK_IN_USER = "BOOKING_CHECK_IN_USER";
export const BOOKING_MANAGER_STATS = "BOOKING_MANAGER_STATS";
export const APPROVED_BOOKING = "APPROVED_BOOKING";
export const REJECTED_BOOKING = "REJECTED_BOOKING";
export const REJECTED_BOOKING_LIST = "REJECTED_BOOKING_LIST";
export const ROOM_BOOKING_LOGS_LIST = "ROOM_BOOKING_LOGS_LIST";
export const ROOM_AVAILABLE_LIST = "ROOM_AVAILABLE_LIST";
export const CREATE_ROOM_AVAILABLE_LIST = "CREATE_ROOM_AVAILABLE_LIST";
export const UPDATE_ROOM_AVAILABLE_LIST = "UPDATE_ROOM_AVAILABLE_LIST";
export const DELETE_ROOM_AVAILABLE_LIST = "DELETE_ROOM_AVAILABLE_LIST";
export const CREATE_ROOM_LOCATION = "CREATE_ROOM_LOCATION";
export const GET_ROOM_LOCATION = "GET_ROOM_LOCATION";
export const UPDATE_ROOM_LOCATION = "UPDATE_ROOM_LOCATION";
export const DELETE_ROOM_LOCATION = "DELETE_ROOM_LOCATION";
export const CHECK_IN_BOOKING = "CHECK_IN_BOOKING";
export const GET_ROOM_STATUS = "get_leave_status";
export const GET_ROOM_STATUS_ERROR = "get_leave_status_error";
export const GET_ROOM_MAN_LOGS = "GET_ROOM_MAN_LOGS";
export const GET_ROOM_MAN_LOGS_ERROR = "GET_ROOM_MAN_LOGS_ERROR";
// doctor
export const DOCTOR_LOGS = "doctor_logs";
export const DOCTOR_LOGS_ERROR = "doctor_logs_erros";
export const DOCTOR_STATUS = "doctor_status";
export const DOCTOR_STATUS_ERROR = "doctor_staus_error";
// front desk
export const GET_FRONT_DESK = "GET_FRONT_DESK";
export const GET_FRONT_DESK_ERROR = "GET_FRONT_DESK_ERROR";
export const UPDATE_FRONT_DESK = "GET_FRONT_DESK";
export const UPDATE_FRONT_DESK_ERROR = "GET_FRONT_DESK_ERROR";
// news and Updats
export const GET_NEWS = "get_news";
export const GET_NEWS_ERROR = " get_news_error";
export const CREATE_NEWS = "create_news";
export const CREATE_NEWS_ERROR = "create_news_error";
export const UPDATE_NEWS = "update_news";
export const UPDATES_NEWS_ERROR = "update_news_error";
export const DELETE_NEWS = "delete_news";
export const DELETE_NEWS_ERROR = "delete_news_error";
// ISSUE MANAGEMENT
export const CREATE_ISSUE_REQUEST = "CREATE_ISSUE_REQUEST";
export const GET_ISSUE_REQUEST_LIST = "GET_ISSUE_REQUEST_LIST";
export const UPDATE_ISSUE_REQUEST = "UPDATE_ISSUE_REQUEST";
export const DELETE_ISSUE_REQUEST = "DELETE_ISSUE_REQUEST";
export const CREATE_ISSUE_CATEGORY = "CREATE_ISSUE_CATEGORY";
export const GET_ISSUE_CATEGORY = "GET_ISSUE_CATEGORY";
export const UPDATE_ISSUE_CATEGORY = "UPDATE_ISSUE_CATEGORY";
export const DELETE_ISSUE_CATEGORY = "DELETE_ISSUE_CATEGORY";
export const GET_ISSUE_DETAIL_LIST = "GET_ISSUE_DETAIL_LIST";

export const UPDATE_ISSUE_STATUS = "UPDATE_ISSUE_STATUS";
export const GET_ISSUE_APPROVAL_LIST = "GET_ISSUE_APPROVAL_LIST";
export const GET_ISSUE_MANAGER_LOG = "GET_ISSUE_MANAGER_LOG";
export const UPDATE_ISSUE_COMPLETE = "UPDATE_ISSUE_COMPLETE";
export const UPDATE_ISSUE_CLOSE = "UPDATE_ISSUE_CLOSE";
export const ASSIGNED_ISSUE_APPROVAL = "ASSIGNED_ISSUE_APPROVAL";
export const DELETE_FILE_ISSUE_REQUEST = "DELETE_FILE_ISSUE_REQUEST";
// PERFORMANCE
export const CREATE_PROJECT = "CREATE_PROJECT";
export const GET_PROJECT_LIST = "GET_PROJECT_LIST";
export const UPDATE_PROJECT_LIST = "UPDATE_PROJECT_LIST";
export const DELETE_PROJECT_LIST = "DELETE_PROJECT_LIST";
export const CREATE_PROJECT_TASK = "CREATE_PROJECT_TASK";
export const GET_PROJECT_TASK_LIST = "GET_PROJECT_TASK_LIST";
export const UPDATE_PROJECT_TASK_LIST = "UPDATE_PROJECT_TASK_LIST";
export const DELETE_PROJECT_TASK_LIST = "DELETE_PROJECT_TASK_LIST";
export const CREATE_GOAL = "CREATE_GOAL";
export const GET_GOAL = "GET_GOAL";
export const UPDATE_GOAL = "UPDATE_GOAL";
export const DELETE_GOAL = "DELETE_GOAL";
export const GET_GOAL_DETAILS = "GET_GOAL_DETAILS";
export const ADD_KPI_KRA = "ADD_KPI_KRA";
export const UPDATE_KPI_KRA = "UPDATE_KPI_KRA";
export const GET_OBEJCTIVE_DETAILS = "GET_OBEJCTIVE_DETAILS";
export const DELETE_OBEJCTIVE = "DELETE_OBEJCTIVE";

// Area Master
export const GET_AREA = "GET_AREA";
export const CREATE_AREA = "CREATE_AREA";
export const UPDATE_AREA = "UPDATE_AREA";
export const DELETE_AREA = "DELETE_AREA";
export const CREATE_FEEDBACK = "CREATE_FEEDBACK";
export const GET_FEEDBACK = "GET_FEEDBACK";
export const UPDATE_FEEDBACK = "UPDATE_FEEDBACK";
export const DELLETE_FEEDBACK = "DELETE_FEEDBACK";
export const FEED_BACK_DETAILS = "FEED_BACK_DETAILS";
export const FEED_BACK_QRCODE = "FEED_BACK_QRCODE";
export const SAVE_FEEDBACK_RESPONSE = "SAVE_FEEDBACK_RESPONSE";
export const GET_USERS_FEEDBACK_RESPONSES = "GET_USERS_FEEDBACK_RESPONSES";
//CRM
export const GET_NONMEMBER_LIST = "GET_NONMEMBER_LIST";
export const GET_SOCIALMEDIA_LIST = "GET_SOCIALMEDIA_LIST";
export const GET_MEMBER_LIST = "GET_MEMBER_LIST";
export const GET_CLIENT_DETAIL_ID = "GET_CLIENT_DETAIL_ID";
export const CREATE_CALL_LOGS = "CREATE_CALL_LOGS";
export const UPDATE_CALL_LOGS = "UPDATE_CALL_LOGS";
export const DELETE_CALL_LOGS_FILE = "DELETE_CALL_LOGS_FILE";
export const CREATE_FUND = "CREATE_FUND";
export const UPDATE_FUND = "UPDATE_FUND";
export const UPDATE_FUND_REQUEST_STATUS = "UPDATE_FUND_REQUEST_STATUS";
export const UPLOAD_EXL_SOCAIL_CLIENT = "UPLOAD_EXL_SOCAIL_CLIENT";
export const GET_CRM_FUND_PENDING = "GET_CRM_FUND_PENDING";
export const CRM_STATUS_REQUEST = "CRM_STATUS_REQUEST";
export const CRM_REQUEST_LOGS = "CRM_REQUEST_LOGS";
export const DELETE_FUNDS_INSTALLMENT_FILE = "DELETE_FUNDS_INSTALLMENT_FILE";
export const ADD_INSTALLMENT = "ADD_INSTALLMENT";
export const UPDATE_INSTALLMENT = "UPDATE_INSTALLMENT";
export const UPLOAD_EXCEL_FILE = "UPLOAD_EXCEL_FILE";
// Home
export const GET_USER_BDAY = "GET_USER_BDAY";
export const WISH_USER_BDAY = "WISH_USER_BDAY";
export const GET_NEWS_UPDATE = "GET_NEWS_UPDATE";
export const GET_NEWS_DETAILS = "GET_NEWS_DETAILS";
export const NOTIFICATIONS = "NOTIFICATIONS";
export const READ_NOTIFICATIONS = "READ_NOTIFICATIONS";
// attendence
export const GET_ATTENDENCE = "GET_ATTENDENCE";
export const USER_FILTER_ATTENDENCE = "USER_FILTER_ATTENDENCE";
export const ALL_USER_ATTENDENCE = "ALL_USER_ATTENDENCE";
export const USER_UNDER_MANAGER = "USER_UNDER_MANAGER";
export const GET_PRESENT_ATTENDENCE_COUNT = "GET_PRESENT_ATTENDENCE_COUNT";
export const GET_ALL_DEVICE_NAME_ATTENDENCE = "GET_ALL_DEVICE_NAME_ATTENDENCE";

// MASTERS
export const GET_ALL_DEPARTMENTS = "GET_ALL_DEPARTMENTS";
export const CREATE_DEPARTMENT = "CREATE_DEPARTMENT";
export const UPDATE_DEPARTMENT = "UPDATE_DEPARTMENT";
export const VERIFY_USER = "VERIFY_USER";
// USER MANAGEMENT
export const GET_ALL_ASHRAMWASI_USERS = "GET_ALL_ASHRAMWASI_USERS";
export const ADD_USER = "ADD_USER";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";

// POLICIES & MANUALS

export const GET_POLICIES_MANUALS = "GET_POLICIES_MANUALS";
export const CREATE_POLICIES_MANUALS = "CREATE_POLICIES_MANUALS";
export const UPDATE_POLICIES_MANUALS = "UPDATE_POLICIES_MANUALS";
export const DELETE_POLICIES_MANUALS = "DELETE_POLICIES_MANUALS";
export const GET_POLICIES_MANUALS_ITEM = "GET_POLICIES_MANUALS_ITEM";
export const CREATE_POLICIES_MANUALS_ITEM = "CREATE_POLICIES_MANUALS_ITEM";
export const UPDATE_POLICIES_MANUALS_ITEM = "UPDATE_POLICIES_MANUALS_ITEM";
export const DELETE_POLICIES_MANUALS_ITEM = "DELETE_POLICIES_MANUALS_ITEM";

// SOS
export const GET_SOS_LIST = "GET_SOS_LIST";

// REPORTS

export const GET_ISSUE_REPORT = "GET_ISSUE_REPORT";
export const GET_LOCATION_WISE_CATEGORY_ISSUE_REPORT =
    "GET_LOCATION_WISE_CATEGORY_ISSUE_REPORT";
export const GET_STATUS_WISE_COUNT_ISSUE_REPORT =
    "GET_STATUS_WISE_COUNT_ISSUE_REPORT";

export const GET_ATTENDANCE_REPORT = "GET_ATTENDANCE_REPORT";
export const GET_TYPE_OF_LEAVE_APPLIED_COUNT_REPORT =
    "GET_TYPE_OF_LEAVE_APPLIED_COUNT_REPORT";
export const GET_STATUS_OF_LEAVE_COUNT_REPORT =
    "GET_STATUS_OF_LEAVE_COUNT_REPORT";
export const GET_LEAVE_REPORT = "GET_LEAVE_REPORT";
export const GET_ROOM_BOOKING_REPORT = "GET_ROOM_BOOKING_REPORT";
export const GET_FEEDBACK_REPORT = "GET_FEEDBACK_REPORT";
export const GET_BIRTHDAY_REPORT = "GET_BIRTHDAY_REPORT";
